<div class="page-container topspaces">
  <piqet-angular-breadcrumbs
    [activatedPath]="activatedRoute"
    [projectName]="productName"
  ></piqet-angular-breadcrumbs>
  <div class="page-content responsive-height">
    <div class="container-fluid">
      <div class="mainDiv d-flex margin-top-10">
        <div class="sideMenu responsive-height">
          <piqet-angular-product-sidebar
            (productNameEvent)="handleName($event)"
          ></piqet-angular-product-sidebar>
        </div>
        <div class="contentDiv" id="scrollableDiv">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </div>
</div>
